import { render, staticRenderFns } from "./BannerTest3.vue?vue&type=template&id=bee5fe78&scoped=true&"
import script from "./BannerTest3.vue?vue&type=script&lang=js&"
export * from "./BannerTest3.vue?vue&type=script&lang=js&"
import style0 from "./BannerTest3.vue?vue&type=style&index=0&id=bee5fe78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee5fe78",
  null
  
)

export default component.exports